import {Component, Inject, OnInit, Optional} from '@angular/core';
import {APP_DIALOG_DATA, DialogService} from "../../../core/services/dialog.service";

export interface DialogInput {
  title: string;
  content: string;
  submitText: string;
  cancelText: string | null;
  isImportant?: boolean;
  isError?: boolean;
}

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    standalone: false
})
export class DialogComponent implements OnInit {
  title: string = this.data.title;
  content: string = this.data.content;
  submitText: string = this.data.submitText;
  cancelText: string | null = this.data.cancelText;
  isImportant: boolean = !!this.data.isImportant;
  isError: boolean = !!this.data.isError;

  constructor(
    private dialogService: DialogService,
    @Inject(APP_DIALOG_DATA) @Optional() readonly data?: any,
  ) {
  }

  ngOnInit(): void {
  }

  submit() {
    this.dialogService.hide(true);
  }

  cancel() {
    this.dialogService.hide(false);
  }
}
